import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase';
import AddManualTeamPlayer from '../Templates/AddManualTeamPlayer';

function AddManualTeam({draw, players, roundId, hostcupId}) {

    
    const [playerSelected, setPlayerSelected] = useState()
    

    const [playersFiltered, setPlayersFiltered] = useState(players);

    const [searchTerm, setSearchTerm] = useState("");

    const [drawNumber, setDrawNumber] = useState("1")
    const [playersAdded, setPlayersAdded] = useState([])

    useEffect(() => {

        if (searchTerm) {
            const filteredArray = players.filter(player => {
                return player.player_name.toLowerCase().includes(searchTerm.toLowerCase())
            })
            setPlayersFiltered(filteredArray)
        }

    }, [searchTerm])





    function saveManualTeam() {
        try {
            const teamsRoundRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("teams");
            const data = {
                teams: playersAdded,
                draw: drawNumber
            }
            teamsRoundRef.add(data);
        } catch (error) {
            console.log(error)
        }
    }

        return (
            <div>
                <h2 className="my-5 text-center font-weight-bold">Legg til spiller på lag manuelt</h2>

                <input className="form-control mb-2" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

                <label>Spiller</label>
                {playersFiltered.map((player, index) => {
                    return (
                        <AddManualTeamPlayer 
                            key={index} 
                            player={player}
                            playerSelected={playerSelected}
                            setPlayerSelected={setPlayerSelected}
                            playersAdded={playersAdded}
                            setPlayersAdded={setPlayersAdded}
                        />
                    )
                })}



                <div className="my-5">
                <h2 className="font-weight-bold">Spillere lagt til ({playersAdded.length})</h2>
                    <ul className="list-group">
                        {playersAdded?.map((player, index) => {
                            return <li  className="list-group-item" key={index}>{player.team_name} {player.player_name}</li>
                        })}
                    </ul>
                </div>



                <h4>Lagre generert lag</h4>
                <label>Trekning</label>
                <input type="number" value={drawNumber} onChange={e => setDrawNumber(e.target.value)} className="form-control mb-2" />
                <button className="btn btn-block btn-success" onClick={saveManualTeam}>Lagre</button>

            </div>
        )

}
export default AddManualTeam